import { render, staticRenderFns } from "./TpvOk.vue?vue&type=template&id=78daf6f5&scoped=true&"
import script from "./TpvOk.vue?vue&type=script&lang=js&"
export * from "./TpvOk.vue?vue&type=script&lang=js&"
import style0 from "./TpvOk.vue?vue&type=style&index=0&id=78daf6f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78daf6f5",
  null
  
)

export default component.exports